/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_OptionalInputs */

const en_notes_optional = /** @type {(inputs: Notes_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes (optional)`)
};

const es_notes_optional = /** @type {(inputs: Notes_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas (opcional)`)
};

/**
* | output |
* | --- |
* | "Notes (optional)" |
*
* @param {Notes_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_optional = /** @type {((inputs?: Notes_OptionalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_OptionalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_optional(inputs)
	return es_notes_optional(inputs)
});